import * as C from 'actions/constants';

export const blankState = {
  list: [],
  campaign: {},
  loading: false,
};

const CampaignsReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_CAMPAIGN:
    case C.LOAD_CAMPAIGNS: {
      return { ...state, loading: true };
    }
    case C.LOAD_CAMPAIGNS_SUCCESS: {
      const { data } = action;
      return { ...state, loading: false, list: data };
    }
    case C.LOAD_CAMPAIGN_SUCCESS: {
      const { data } = action;
      return { ...state, loading: false, campaign: data };
    }
    case C.LOAD_CAMPAIGN_ERROR:
    case C.LOAD_CAMPAIGNS_ERROR: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};

export default CampaignsReducer;
